import { useRef } from 'react'

let idCounter = 0

// Reemplazo de React.useId (React 18) compatible con React >=17 - id estable
// por instancia via un contador de modulo. Sin las garantias de hidratacion SSR
// del useId real, pero Bumper no hace SSR en ningun componente hoy.
export function useId() {
  const idRef = useRef()
  if (idRef.current === undefined) {
    idCounter += 1
    idRef.current = `bumper-id-${idCounter}`
  }
  return idRef.current
}
